// `dateArrivage` est une String serveur, pas un instant ISO typé côté frontend : on se contente
// de couper les 10 premiers caractères (yyyy-MM-dd), exactement comme `libelleArrivage()` dans
// auditeur-confection-selection.component.ts côté sipconfection-frontend. Ne JAMAIS construire
// `new Date(dateArrivage)` ici — piège documenté dans CLAUDE.md (utils/date-export.ts) : un
// instant ISO relu dans le fuseau du navigateur peut annoncer la veille.
/** Horodatage LOCAL (Date.now() du poste, pas une date serveur) — pas de piège de fuseau ici. */
export function heureLocale(timestampMs) {
  return new Date(timestampMs).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

export function jourArrivage(dateArrivage) {
  if (!dateArrivage) return null;
  const jour = dateArrivage.substring(0, 10);
  const [annee, mois, quantieme] = jour.split('-');
  if (!annee || !mois || !quantieme) return jour;
  return `${quantieme}/${mois}/${annee}`;
}
